import Quantum1 from '../Quantum/Quantum (1).webp'
import Quantum2 from '../Quantum/Quantum (2).webp'


const Quantumimages =[
Quantum1,Quantum2
]

export default Quantumimages;